import { useState } from "react";
import { ErrorAlert } from "../../components/alerts";
import { MobileAttractor } from "../../types";
import MobileAttractorImageSettingsContainer from "./MobileAttractorImageSettingsContainer";

type Props = {
  errorMessage: string;
  data: MobileAttractor[];
  getAttractors: () => void;
  onDelete: (id: string | number) => void;
  onUpdate: (attractor: any) => void;
  objectKey: "mobileBannerId" | "mobileAttractorId";
  showPromotionDisplayName?: boolean;
  showTierRestrictions?: boolean;
  showSwapOrder?: boolean;
  setAttractorsData?: (data: MobileAttractor[]) => void;
};
const MobileAttractorsContainer = ({
  errorMessage,
  data,
  getAttractors,
  onUpdate,
  onDelete,
  objectKey,
  showPromotionDisplayName = false,
  showTierRestrictions = false,
  showSwapOrder = false,
  setAttractorsData = () => {
    return;
  },
}: Props) => {
  const [swapLoading, setSwapLoading] = useState(false);

  if (data?.length === 0) {
    return <ErrorAlert message={errorMessage} />;
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {data?.map((d, i: number) => (
        <div key={i}>
          <MobileAttractorImageSettingsContainer
            index={i}
            d={d}
            getAttractors={getAttractors}
            onDelete={onDelete}
            onUpdate={onUpdate}
            objectKey={objectKey}
            showPromotionDisplayName={showPromotionDisplayName}
            showTierRestrictions={showTierRestrictions}
            showSwapOrder={showSwapOrder}
            isLast={i === data.length - 1}
            swapLoading={swapLoading}
            setSwapLoading={setSwapLoading}
            attractorsData={data}
            setAttractorsData={setAttractorsData}
          />
        </div>
      ))}
    </div>
  );
};

export default MobileAttractorsContainer;
